import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Registrationpage from '../Pages/User/RegisterNow/Registrationpage';
import UserRegistrationPage from '../Pages/User/UserRegistration/UserRegistrationpage';
import Enterotppage from '../Pages/User/EnterOTP/Enterotp';
import Dashboard from '../Pages/User/Dashboard/Dashboard';
import BankDetails from '../Pages/User/BankDetails/BankDetails';
import UPIDetails from '../Pages/User/UPIDetails/UPIDetails';
import PaymentMethod from '../Pages/User/PaymentMethod/PaymentMethod';
import TransactionHistory from '../Pages/User/TransactionHistory/TransactionHistory';
import ServerMaintenance from '../Pages/User/ServerMaintenance/ServerMaintenance';
import AmountCredited from '../Pages/User/AmountCredited/AmountCredited';
const AppRoutes = () => {
    return (
        <Routes>
            <Route exact path='/' element={<Registrationpage />} />
            <Route exact path='/:couponCode' element={<Registrationpage />} />
            <Route exact path='/registration' element={<UserRegistrationPage />} />
            <Route exact path='/otp' element={<Enterotppage />} />
            <Route exact path='/dashboard' element={<Dashboard />} />
            <Route exact path='/bankDetails' element={<BankDetails />} />
            <Route exact path='/upiDetails' element={<UPIDetails />} />
            <Route exact path='/paymentMethod' element={<PaymentMethod />} />
            <Route exact path='/transactionHistory' element={<TransactionHistory />} />
            <Route exact path='/serverMaintenance' element={<ServerMaintenance />} />
            <Route exact path='/amountCredited' element={<AmountCredited />} />
        </Routes>
    )
}
export default AppRoutes;